/*
  HHC Free Gift — display only (works with any cart drawer, incl. One Click Upsell).
  For every cart line of the free gift product:
  - shows the original price crossed out, then $0.00 and a FREE badge
  - hides the quantity selector (− 1 +), the gift is always 1
  - makes the title / image NOT clickable (no way to open the gift product page)
  Original price = the gift product's "Compare-at price" in Shopify admin.
  Nothing here changes the cart or prices, it only changes what the customer sees.
*/
(function () {
  var cfgEl = document.getElementById('hhc-free-gift-config');
  if (!cfgEl) return;
  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }
  if (!cfg.enabled || !cfg.giftHandle) return;

  var GIFT_PATH = '/products/' + cfg.giftHandle;
  var DONE = 'data-hhc-gift-price';
  var QTY_HIDDEN = 'data-hhc-gift-qty-hidden';

  function isGiftLink(a) {
    var href = a.getAttribute('href') || '';
    return href.indexOf(GIFT_PATH) !== -1;
  }

  function escapeRe(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  // "$0.00", optionally followed by a currency code ("$0.00 USD")
  var zeroRe = new RegExp('^\\s*' + escapeRe(cfg.zeroPrice || '$0.00') + '(\\s*[A-Z]{3})?\\s*$');

  function hasOtherProducts(el) {
    return Array.prototype.some.call(el.querySelectorAll('a[href*="/products/"]'), function (a) {
      return !isGiftLink(a);
    });
  }

  // The smallest box around the gift link that holds the line's price but no other product
  function lineBoxFor(link) {
    var el = link.parentElement;
    for (var i = 0; el && i < 10; i++, el = el.parentElement) {
      if (hasOtherProducts(el)) return null; // went too far (other cart lines / upsells inside)
      if (el.querySelector('[' + DONE + ']') || findZeroPrices(el).length) return el;
    }
    return null;
  }

  function findZeroPrices(box) {
    var found = [];
    var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var parent = node.parentElement;
      if (!parent || parent.closest('[' + DONE + ']')) continue;
      if (parent.closest('s, del')) continue; // already a crossed-out price
      if (zeroRe.test(node.nodeValue)) found.push(parent);
    }
    return found;
  }

  function decoratePrice(el) {
    el.setAttribute(DONE, '1');
    var html = '';
    if (cfg.comparePrice) html += '<s class="hhc-gift-price__compare">' + cfg.comparePrice + '</s> ';
    html += '<span class="hhc-gift-price__now">' + (cfg.zeroPrice || '$0.00') + '</span>';
    if (cfg.freeLabel) html += ' <span class="hhc-gift-price__free">' + cfg.freeLabel + '</span>';
    el.innerHTML = html;
  }

  // Quantity controls: the qty input, or the − / + buttons
  var QTY_BTN_RE = /quantity|qty|increase|decrease|plus|minus|increment|decrement/i;
  function qtyControls(box) {
    var list = Array.prototype.slice.call(
      box.querySelectorAll('input[type="number"], input[name*="quantity" i], input[name*="qty" i], quantity-input')
    );
    Array.prototype.forEach.call(box.querySelectorAll('button, [role="button"]'), function (b) {
      var txt = (b.textContent || '').trim();
      var label = [b.getAttribute('aria-label'), b.getAttribute('name'), b.className && String(b.className), b.getAttribute('data-action')].join(' ');
      if (txt === '+' || txt === '-' || txt === '\u2212' || txt === '\u2013' || QTY_BTN_RE.test(label)) list.push(b);
    });
    return list;
  }

  // Hide the whole − 1 + group: the biggest wrapper around the control that does not
  // also contain the price, the title link or the remove button
  function hideQty(box) {
    qtyControls(box).forEach(function (ctrl) {
      if (ctrl.closest('[' + QTY_HIDDEN + ']')) return;
      if (/remove|delete|trash/i.test([ctrl.getAttribute('aria-label'), ctrl.className && String(ctrl.className)].join(' '))) return;
      var target = ctrl;
      var el = ctrl.parentElement;
      while (el && el !== box) {
        if (
          el.querySelector('[' + DONE + ']') ||
          el.querySelector('a[href*="' + GIFT_PATH + '"], a[data-hhc-gift-link]') ||
          el.querySelector('[aria-label*="remove" i], [class*="remove" i], [class*="delete" i], [class*="trash" i]')
        ) break;
        target = el;
        el = el.parentElement;
      }
      target.setAttribute(QTY_HIDDEN, '1');
      target.style.setProperty('display', 'none', 'important');
    });
  }

  function disableLink(a) {
    if (a.hasAttribute('data-hhc-gift-link')) return;
    a.setAttribute('data-hhc-gift-link', '1');
    a.removeAttribute('href');
    a.setAttribute('aria-disabled', 'true');
    a.setAttribute('tabindex', '-1');
    a.classList.add('hhc-gift-nolink');
  }

  function run() {
    var links = document.querySelectorAll('a[href*="' + GIFT_PATH + '"]');
    Array.prototype.forEach.call(links, function (a) {
      if (!isGiftLink(a)) return;
      var box = lineBoxFor(a);
      if (box) {
        findZeroPrices(box).forEach(decoratePrice);
        hideQty(box);
      }
      disableLink(a);
    });
  }

  // Block clicks on the gift title/image in any cart UI (also if a link is re-rendered)
  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest && e.target.closest('a');
      if (a && (a.hasAttribute('data-hhc-gift-link') || isGiftLink(a))) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  var t = null;
  function schedule() {
    clearTimeout(t);
    t = setTimeout(run, 30);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  // Cart drawers re-render often — re-apply whenever the page changes
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
